import { View, html } from 'rune-ts';
import klass from './CreatorApplicationSection2.module.scss';
import { font } from '@services/MarppleShop/shared/typography';
import { ChevronRightIcon } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import { makeUtilScreenNavigate } from '@services/MarppleShop/shared/app/navigate';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';

export class CreatorApplicationSection2 extends View<{ is_mobile: boolean }> {
  static CRADS = [
    {
      href: `/${ET.lang}/@/youtube`,
      title: '유튜브 쇼핑',
      is_free_fee: true,
      description_pc: '내 유튜브 채널에서<br />상품 판매 시작해보기',
      description_mo: '유튜브 연동 한 번으로<br />상품 판매 시작',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/c4ee17aec991eef2e82ab27c19c9bd2c92eb33d81.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/28245b86066484613c9eefd0ada4eeb3ee1319b21.png',
    },
    {
      href: `/${ET.lang}/@/handmade`,
      title: '핸드메이드',
      is_free_fee: true,
      description_pc: '핸드메이드 작품으로<br />나만의 브랜드 샵 만들기',
      description_mo: '핸드메이드 작품으로<br />나만의 브랜드 샵 만들기',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/b35d890ebf49f7d84e8bcd66d790153adc5dd2a52.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/973d270c1ef1322445d617d68e077b3449b1e3314.png',
    },
    {
      href: `/${ET.lang}/@/brand_commerce`,
      title: '브랜드 커머스',
      is_free_fee: false,
      description_pc: '브랜드 X 크리에이터 매칭부터<br />커머스 컨설팅까지 제공',
      description_mo: '크리에이터 매칭과<br />커머스 컨설팅 제공',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/def583245fd68923344cb9cf0987e5233942f4d23.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/50d5d9428e2913ec0cf831e2b86de8fa9604f9635.png',
    },
    {
      href: `/${ET.lang}/@/goodspartner`,
      title: '굿즈 파트너스',
      is_free_fee: false,
      description_pc: '마플샵과 협업하여<br />더 특별한 기획상품 만들기',
      description_mo: '마플샵과 협업하여<br />특별한 기획상품 제작',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/5dcbd55b97bbe8253cfd189c6fc86ebd3599729d4.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/54bc38282e3341923b9c4657e4307914c861e0a32.png',
    },
    {
      href: `/${ET.lang}/@/popupstore/offline`,
      title: '오프라인 팝업스토어',
      is_free_fee: false,
      description_pc: '팝업의 성지, 성수동에<br />나만의 팝업스토어 오픈하기',
      description_mo: '팝업의 성지, 성수동에<br />나만의 팝업스토어 오픈',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/cf9a040829e045039d9097d7f80ebccdb67b46f52.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/45d53e6fd4023ef84532051dea2e1cdb5fb6f7ae1.png',
    },
    {
      href: `/${ET.lang}/@/commerce_creator`,
      title: '커머스 크리에이터',
      is_free_fee: false,
      description_pc: '좋아하는 브랜드와 함께<br />내 채널 수익 늘리기',
      description_mo: '브랜드와 함께<br />채널 수익 늘리기',
      img_pc: '//s3.marpple.co/files/u_29089/2025/9/original/14d27a3846c129eed8845614ee3931d552559afb6.png',
      img_mo: '//s3.marpple.co/files/u_29089/2025/9/original/86f7987518cdcdf11ada8da18937065edeee3a5c6.png',
    },
  ];

  protected override template() {
    const { is_mobile } = this.data;
    if (is_mobile) {
      return html` <section class="${klass.section}">
        <div class="${klass.section2}">
          <div class="${klass.promotion_title}">
            <h2 class="${font('20_bold')}">당신을 위한 다양한 성장 기회</h2>
            <p class="${font('14_medium')}">
              유튜브 쇼핑 연동, 굿즈 제작·판매, 커머스 컨설팅까지<br />마플샵에서 새로운 기회를 만나보세요.
            </p>
          </div>
          <div class="${klass.promotion_cards}">
            ${CreatorApplicationSection2.CRADS.map(({ href, title, is_free_fee, description_mo, img_mo }) => {
              return html`
                <a
                  href="${href}"
                  class="${klass.promotion_card}"
                  data-post-message="${dataStr(makeUtilScreenNavigate(href))}"
                >
                  <div class="${klass.card_left}">
                    <div class="${klass.card_title}">
                      <span class="${font('16_bold')}">${title}</span>${is_free_fee
                        ? html`<span class="${klass.free_fee} ${font('10_bold')}">수수료 0%</span>`
                        : ''}${ChevronRightIcon}
                    </div>
                    <div class="${klass.card_description} ${font('14_medium')}">
                      ${html.preventEscape(description_mo)}
                    </div>
                  </div>
                  <div class="${klass.card_right}">
                    <img src="${img_mo}" alt="" />
                  </div>
                </a>
              `;
            })}
          </div>
        </div>
      </section>`;
    }

    return html`
      <section class="${klass.section}">
        <div class="${klass.section2}">
          <div class="${klass.promotion_title}">
            <h2 class="${font('32_bold')}">굿즈부터 디지털까지, 크리에이터 올인원 커머스</h2>
            <p class="${font('20_medium')}">
              유튜브 쇼핑 연동, 굿즈 제작·판매, 커머스 컨설팅까지 마플샵에서 새로운 기회를 만나보세요.
            </p>
          </div>
          <div class="${klass.promotion_cards}">
            ${CreatorApplicationSection2.CRADS.map(({ href, title, is_free_fee, description_pc, img_pc }) => {
              return html`
                <a href="${href}" class="${klass.promotion_card}">
                  <div class="${klass.card_left}">
                    <div class="${klass.card_title}">
                      <span class="${font('20_bold')}">${title}</span>${is_free_fee
                        ? html`<span class="${klass.free_fee} ${font('10_bold')}">수수료 0%</span>`
                        : ''}${ChevronRightIcon}
                    </div>
                    <div class="${klass.card_description} ${font('16_medium')}">
                      ${html.preventEscape(description_pc)}
                    </div>
                  </div>
                  <div class="${klass.card_right}">
                    <img src="${img_pc}" alt="" />
                  </div>
                </a>
              `;
            })}
          </div>
        </div>
      </section>
    `;
  }
}
